import { apiFetch } from '@/shared/api/client'
import type { DelmanSession } from '@/shared/auth/delmanSessionStorage'
import { clearKitchenSession } from '@/shared/auth/sessionStorage'

import { isMockApi } from '@/shared/env'
type DelmanPinLoginRequest = {
  device_id: string
  pin: string
}

type DelmanPinLoginResponse = {
  access_token: string
  user: {
    id: string
    name: string
    role: 'DELMAN'
  }
}

const DEV_PIN = '123456'

function useMockApi(): boolean {
  return isMockApi
}

function mapToSession(payload: DelmanPinLoginResponse): DelmanSession {
  return {
    accessToken: payload.access_token,
    userId: payload.user.id,
    userName: payload.user.name,
    role: payload.user.role,
    loggedInAt: new Date().toISOString(),
  }
}

function mockPinLogin(req: DelmanPinLoginRequest, delmanName?: string): DelmanSession {
  if (req.pin !== DEV_PIN) {
    throw new Error('PIN salah. Coba lagi atau hubungi Admin HO jika lupa PIN.')
  }

  return {
    accessToken: `mock-delman-token-${req.device_id}`,
    userId: 'delman-budi',
    userName: delmanName ?? 'Budi Santoso',
    role: 'DELMAN',
    loggedInAt: new Date().toISOString(),
  }
}

export async function loginDelmanPin(
  req: DelmanPinLoginRequest,
  delmanName?: string,
): Promise<DelmanSession> {
  if (useMockApi()) {
    await new Promise((resolve) => setTimeout(resolve, 450))
    return mockPinLogin(req, delmanName)
  }

  const payload = await apiFetch<DelmanPinLoginResponse>('/auth/pin-login', {
    method: 'POST',
    body: JSON.stringify(req),
  })
  clearKitchenSession()
  return mapToSession(payload)
}
